module.exports = __webpack_public_path__ + "static/media/eve-dot.e2f8abd6.svg";